import { createSlice } from '@reduxjs/toolkit';
const SLICE_NAME = 'newPasswordModalSlice';

export const newPasswordSlice = createSlice({
    name: SLICE_NAME,
    initialState: {
        isOpen: false,
    },
    reducers: {
        toggleNewPasswordModal(state) {
            state.isOpen = !state.isOpen;
        },
    },
});

export const { toggleNewPasswordModal } = newPasswordSlice.actions;

export const newPasswordModalStateSelector = (state) =>
    state.newPasswordModal.isOpen;

export const newPasswordModal = newPasswordSlice.reducer;
